export const removeMask = (value: string) =>
  value.replace(/\D/g, "");
